import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function TomosSection() {
  const tomos = [{
    num: '1',
    title: 'Mentalidad Digital y Home Office',
    desc: 'Setup completo, herramientas, mentalidad 40+'
  }, {
    num: '2',
    title: 'Excel Nivel Semilla',
    desc: 'Las 10 fórmulas esenciales, planillas profesionales'
  }, {
    num: '3',
    title: 'Mail Master',
    desc: 'Comunicación corporativa, 50 plantillas listas'
  }, {
    num: '4',
    title: 'Google Calendar y Agenda Perfecta',
    desc: 'Time Blocking, eventos, coordinación de reuniones'
  }, {
    num: '5',
    title: 'Excel Avanzado para Asistentes',
    desc: 'Reportes, tablas dinámicas, dashboards'
  }, {
    num: '6',
    title: 'Tu Lanzamiento',
    desc: 'CV, LinkedIn, paquetes, primer cliente'
  }];
  const includes = ['Lenguaje claro — sin tecnicismos', '4 ejercicios prácticos por tomo', 'Plantillas y checklists listos para usar', 'Método Visual-Step 40+'];
  return <section className="bg-nightDeep py-12" data-id="element-273">
      <div className="max-w-6xl mx-auto px-6" data-id="element-274">
        <div className="text-center mb-10" data-id="element-275">
          <div className="inline-flex items-center justify-center gap-2 px-4 py-1.5 rounded-full bg-gold-accent/10 border border-gold-accent/30 text-gold-accent font-bold text-sm tracking-wider mb-4" data-id="element-276">
            🏆 SECRETARIA VIRTUAL DESDE CERO
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-277">
            6 Tomos + 6 Bonos
          </h2>
          <p className="text-xl text-textLight" data-id="element-278">De cero al primer cliente</p>
        </div>

        <h3 className="text-2xl font-bold text-center text-white mb-6 flex items-center justify-center gap-3" data-id="element-279">
          <span className="w-12 h-[1px] bg-white/20" data-id="element-280"></span>
          📚 LOS 6 TOMOS
          <span className="w-12 h-[1px] bg-white/20" data-id="element-281"></span>
        </h3>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10" data-id="element-282">
          {tomos.map((tomo, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="glass rounded-2xl p-6 hover:border-gold-accent/40 transition-colors group" data-id="element-283">
              <div className="w-12 h-12 bg-gold-accent text-night rounded-xl flex items-center justify-center font-bold text-xl mb-4 shadow-lg shadow-gold-accent/20" data-id="element-284">
                {tomo.num}
              </div>
              <h4 className="text-xl font-bold text-white mb-2" data-id="element-285">
                {tomo.title}
              </h4>
              <p className="text-textLight" data-id="element-286">{tomo.desc}</p>
            </motion.div>)}
        </div>

        <div className="glass rounded-2xl p-8 md:p-10 max-w-4xl mx-auto relative overflow-hidden" data-id="element-287">
          <h4 className="text-2xl font-bold mb-6 text-center text-gold-accent" data-id="element-288">
            Cada tomo incluye:
          </h4>
          <div className="grid sm:grid-cols-2 gap-y-4 gap-x-8" data-id="element-289">
            {includes.map((item, idx) => <div key={idx} className="flex items-center gap-3" data-id="element-290">
                <CheckCircle2 className="w-6 h-6 text-gold-accent flex-shrink-0" data-id="element-291" />
                <span className="font-medium text-white" data-id="element-292">{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}